import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { dark } = colors;

const fontFamily = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

const baseHeadingProperties = {
  fontFamily,
  color: dark.main,
  fontWeight: 700,
  letterSpacing: "-0.02em",
};

const typography = {
  fontFamily,
  fontWeightLighter: 100,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,

  h1: { fontSize: pxToRem(48), lineHeight: 1.15, ...baseHeadingProperties },
  h2: { fontSize: pxToRem(36), lineHeight: 1.2, ...baseHeadingProperties },
  h3: { fontSize: pxToRem(30), lineHeight: 1.25, ...baseHeadingProperties },
  h4: { fontSize: pxToRem(24), lineHeight: 1.3, ...baseHeadingProperties },
  h5: { fontSize: pxToRem(20), lineHeight: 1.35, ...baseHeadingProperties, letterSpacing: "-0.01em" },
  h6: { fontSize: pxToRem(16), lineHeight: 1.4, ...baseHeadingProperties, letterSpacing: "0" },

  subtitle1: { fontFamily, fontSize: pxToRem(20), fontWeight: 500, lineHeight: 1.5 },
  subtitle2: { fontFamily, fontSize: pxToRem(16), fontWeight: 500, lineHeight: 1.5 },

  body1: { fontFamily, fontSize: pxToRem(16), fontWeight: 400, lineHeight: 1.6 },
  body2: { fontFamily, fontSize: pxToRem(14), fontWeight: 400, lineHeight: 1.6 },

  button: { fontFamily, fontSize: pxToRem(14), fontWeight: 500, lineHeight: 1.5, textTransform: "none" },
  caption: { fontFamily, fontSize: pxToRem(12), fontWeight: 400, lineHeight: 1.4 },
  overline: { fontFamily, fontSize: pxToRem(10), fontWeight: 600, lineHeight: 1.5, textTransform: "uppercase", letterSpacing: "0.08em" },

  size: {
    xxs: pxToRem(10),
    xs: pxToRem(12),
    sm: pxToRem(14),
    md: pxToRem(16),
    lg: pxToRem(18),
    xl: pxToRem(20),
    "2xl": pxToRem(24),
    "3xl": pxToRem(30),
  },
};

export default typography;
